import { Pipe, PipeTransform } from '@angular/core';
import { ModaliteReunion } from '../../models/modaliteReunion';

@Pipe({
	name: 'filterModaliteReunionByName'
})
export class FilterModaliteReunionByNamePipe implements PipeTransform {
	transform(modaliteReunion: ModaliteReunion[], filter: string): ModaliteReunion[] {
		if (
			!modaliteReunion ||
			!filter ||
			modaliteReunion === null ||
			filter === null ||
			filter === ''
		) {
			return modaliteReunion;
		}

		return modaliteReunion.filter((modaliteReunion: ModaliteReunion) => {
			if (modaliteReunion.name) {
				// TODO: add lastName too
				return modaliteReunion.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
